var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12505 19.1L0.700048 10.7C0.600048 10.6 0.529382 10.4917 0.488049 10.375C0.446049 10.2583 0.425049 10.1333 0.425049 9.99999C0.425049 9.86666 0.446049 9.74166 0.488049 9.62499C0.529382 9.50833 0.600048 9.39999 0.700048 9.29999L9.12505 0.874994C9.35838 0.64166 9.65005 0.524994 10 0.524994C10.35 0.524994 10.65 0.649994 10.9 0.899994C11.15 1.14999 11.275 1.44166 11.275 1.77499C11.275 2.10833 11.15 2.39999 10.9 2.64999L3.55005 9.99999L10.9 17.35C11.1334 17.5833 11.25 17.8707 11.25 18.212C11.25 18.554 11.125 18.85 10.875 19.1C10.625 19.35 10.3334 19.475 10 19.475C9.66671 19.475 9.37505 19.35 9.12505 19.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.5fbf2c1a387d6cdd2d126a4fdbdd344f.svg";
export { ForwardRef as ReactComponent };